import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import { useSelector } from 'react-redux';
import { Tools } from 'react-bootstrap-icons';
import { useHistory } from 'react-router-dom';
const GuaranteeStatusResult = () => {
    const result = useSelector(state => state.guaranteeCardsReducer?.cardsStatus)
    const isLoading = useSelector(state => state.loading?.isLoading);
    const history = useHistory();
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
    },[]);
    const openService = () => {
        if (result.RelatedProductID) {
            result.ProductID = result.RelatedProductID;
        }
        if (result.RelatedProductModel) {
            result.ProductModel = result.RelatedProductModel;
        }
        if (result.RelatedProductName) {
            result.ProductName = result.RelatedProductName;
        }
        result.SupportID = 1;
        if (result.GuarantyEndDateTime) {
            result.GuaranteeEndDate = result.GuarantyEndDateTime;
        }
        if (result.GuarantyStartDateTime) {
            result.GuaranteeStartDate = result.GuarantyStartDateTime;
        }
        if (result.GuarantyCode) {
            result.GuaranteeCardNo = result.GuarantyCode;
        }
        history.push(`/Services/Service/0/0`, result);
    }
    return (
        <div className="container-fuid mt-2">
            <br />
            {isLoading && <Loader type="BallTriangle" color="#bb1370" height={50} width={50} />}
            {!isLoading && result.GuarantyStatus &&
                <div className="card col-md-5" style={{ textAlign: "right", margin: "auto" }}>
                    <div className='card-header headerStyle'>
                        نتیجه استعلام
                    </div>
                    <div className="cardBody row bodyStyle mt-1" style={{ paddingRight: "6px", paddingBottom: "3px", margin: "0" }}>
                        <div className="col-4" style={{ marginBottom: "4px", color:"blue" }}>‏وضعیت کارت</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.GuarantyStatus}</div>
                        <div className="col-4" style={{ marginBottom: "4px", color:"blue" }}>‏وضعیت استفاده</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.IsUsedInServices ? ("استفاده شده") : ("استفاده نشده")}</div>
                        <div className="col-4" style={{ marginBottom: "4px" }}>‏شماره کارت</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.GuarantyCode}</div>
                        <div className="col-4" style={{ marginBottom: "4px" }}>‏شماره سریال</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.SerialNumber}</div>
                        <div className="col-4" style={{ marginBottom: "4px" }}>‏برند</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.HolderName}</div>                        
                        <div className="col-4" style={{ marginBottom: "4px" }}>نام کالا</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.RelatedProductName}</div>
                        <div className="col-4" style={{ marginBottom: "4px" }}>مدل کالا</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.RelatedProductModel}</div>
                        <div className="col-4" style={{ marginBottom: "4px" }}>‏تاریخ آغاز گارانتی</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.GuarantyStartDate}</div>
                        <div className="col-4" style={{ marginBottom: "4px" }}>‏تاریخ پایان گارانتی</div><div className="col-7" style={{ marginBottom: "2px" }}>{result.GuarantyEndDate}</div>
                    </div>
                    <div className='card-footer'>
                        {!result.IsUsedInServices && !result.IsGuarantyCanceled && result.GuarantyStatus === "گارانتی دارد." && <Button className='group-Btn' onClick={openService}><Tools size={14} />&nbsp;&nbsp;ثبت پذیرش</Button>}
                    </div>
                </div>
            }
            {!isLoading && !result.GuarantyStatus &&
                <div className="card  col-md-5" style={{ margin: "auto" }}>
                    <div className='card-header headerStyle'>
                        نتیجه استعلام
                    </div>
                    <div className="cardBody bodyStyle" style={{ paddingTop: "65px", height: '150px' }}>
                        کارتی با این مشخصات یافت نشد!
                    </div>
                </div>
            }
        </div>
    )
}
export default GuaranteeStatusResult;